import { CHALLENGES } from '../../constants/tabs'
import { isArray, union } from 'lodash'
import setChallengesCompletedCount from '../../utils/setChallengesCompletedCount'

const initialState = {
  challenges: {
    activeTab: CHALLENGES,
    icons: [],
    newIcons: [],
  },
}

const reducers = {
  setChallengesActiveTab(state, { payload: activeTab }) {
    state.challenges.activeTab = activeTab
  },
  clearNewIcons(state, { payload: clearIcons }) {
    const { newIcons } = state.challenges
    state.challenges.newIcons = newIcons.filter((icon) => !clearIcons.includes(icon))
  },
}

const matchers = [
  [
    ({ type }) => type === 'requests/data/icons/fulfilled',
    (state, { payload: { icons = [], newIcons = [] } = {} } = {}) => {
      state.challenges.icons = icons

      const { newIcons: prevNewIcons } = state.challenges
      state.challenges.newIcons = union(prevNewIcons, newIcons)
    },
  ],
  [
    ({ type }) => type === 'requests/game/get-quests/fulfilled',
    (state, { payload }) => {
      const quests = payload?.quests ?? []
      state.quests = quests
        .sort((a, b) => b.isComplete - a.isComplete)
        .sort((a, b) => a.isCollected - b.isCollected)
        .filter(({ isAvailable }) => isAvailable)
        .map(setChallengesCompletedCount)
    },
  ],
  [
    ({ type }) => type === 'requests/game/complete-quest/fulfilled',
    (state, { payload }) => {
      const { quest: completedQuest } = payload ?? {}

      state.quests = state.quests.map((quest) => {
        if (quest.id === completedQuest?.id) return setChallengesCompletedCount(completedQuest)

        if (isArray(quest.subQuests))
          quest.subQuests = quest.subQuests.map((subQuest) =>
            subQuest.id === completedQuest?.id ? completedQuest : subQuest,
          )

        return quest
      })
    },
  ],
  [
    ({ type }) => type === 'requests/game/collect-quest/fulfilled',
    (state, { payload }) => {
      const { quest: collectedQuest } = payload ?? {}

      state.quests = state.quests.map((quest) => {
        if (quest.id === collectedQuest?.id) return setChallengesCompletedCount(collectedQuest)

        if (isArray(quest.subQuests))
          quest.subQuests = quest.subQuests.map((subQuest) =>
            subQuest.id === collectedQuest?.id ? collectedQuest : subQuest,
          )

        return quest
      })
    },
  ],
]

export const challengesSegment = {
  initialState,
  reducers,
  matchers,
}
